import axios from 'axios';
import { checkOriginNonProd, decodeToken, getUrlConfigApi, getUrlSecurityApi } from '../utils/util';

export const TOKEN_KEY = 'auth-token';
export const USER_CURRENT_VISION = 'log-current-vision';
export const isAuthenticated = (callbackAfterRefreshToken) => {
    const result = validadeToken(callbackAfterRefreshToken);
    return result;
};
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getVision = () => getUser().vision;
export const getUser = () => {
    let user = localStorage.getItem('user');
    if (user !== null) {
        user = JSON.parse(user);
    }
    return user;
};
export const headersWithAuthorization = () => {
    return new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
        Pragma: 'no-cache',
        'cache-control': 'no-cache',
    });
};

export const validadeToken = (callback) => {
    const token = localStorage.getItem(TOKEN_KEY);
    let result = true;
    if (token !== null && token !== undefined) {
        const decoded = decodeToken(token);
        const expires = new window.Date((decoded.exp * 1000));
        const now = new window.Date();
        if (expires < now) {
            logout();
            result = false;
        } else {
            expires.setMinutes(expires.getMinutes() - 5);
            if (expires < now) {
                const currentVision = localStorage.getItem(USER_CURRENT_VISION);
                refreshToken(currentVision, (resultRefreshToken) => {
                    if (callback) {
                        callback(resultRefreshToken);
                    }
                });
            }
        }
    } else {
        result = false;
    }

    return result;
};

export const refreshToken = (vision, callback) => {
    const uri = checkOriginNonProd(window) ? `${getUrlSecurityApi(window)}/security/vision/${vision}/refreshtoken` : `${getUrlConfigApi(window)}/security/vision/${vision}/refreshtoken`;
    const token = getToken();
    return axios.post(uri, null, {
        headers: { Authorization: `Bearer ${token}` }
    }).then((userResult) => {
        if (userResult) {
            const decoded = decodeToken(userResult.data.acesstoken);

            const user = {
                name: decoded.nameid,
                userName: decoded.unique_name,
                email: decoded.email,
                token: userResult.data.acesstoken,
                vision: decoded.CurrentVision,
                resource: undefined,
                visions: JSON.parse(decoded.VISIONS),
                culture: localStorage.getItem('i18nextLng'),
            };
            login(user, user.token);
            console.log('refreshtoken');
            if (callback) {
                callback(user);
            }
        }
    });
};

export const checkPermission = (permission) => {
    const user = getUser();
    if (!user || !user.token) {
        return false;
    }
    const decoded = decodeToken(user.token);
    return !!(decoded && decoded.role && decoded.role.find((i) => i === permission));
};

export const login = (user, token) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem('user', JSON.stringify(user));
};

export const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('user');
    localStorage.removeItem(USER_CURRENT_VISION);
    console.log("reload cache")
    window.location.reload(true)
    if (navigator.userAgent === 'logisticspwa') {
        const content = window.ReactNativeWebView;
        if (content) {
            content.postMessage(JSON.stringify({ messageType: 'logoutClearCookieManager', value: true }));
        }
    }
};

export const setVision = (vision) => {
    localStorage.setItem(USER_CURRENT_VISION, vision);
};
